__turbopack_context__.v({
  "accordionSlideOverwrite": "eventSlideOut-module-scss-module__tztGla__accordionSlideOverwrite",
  "actionButton": "eventSlideOut-module-scss-module__tztGla__actionButton",
  "actions": "eventSlideOut-module-scss-module__tztGla__actions",
  "backLink": "eventSlideOut-module-scss-module__tztGla__backLink",
  "backLinkArrow": "eventSlideOut-module-scss-module__tztGla__backLinkArrow",
  "backLinkText": "eventSlideOut-module-scss-module__tztGla__backLinkText",
  "badgeSection": "eventSlideOut-module-scss-module__tztGla__badgeSection",
  "badges": "eventSlideOut-module-scss-module__tztGla__badges",
  "badgesContainer": "eventSlideOut-module-scss-module__tztGla__badgesContainer",
  "badgesHeading": "eventSlideOut-module-scss-module__tztGla__badgesHeading",
  "content": "eventSlideOut-module-scss-module__tztGla__content",
  "contentContainer": "eventSlideOut-module-scss-module__tztGla__contentContainer",
  "divider": "eventSlideOut-module-scss-module__tztGla__divider",
  "error": "eventSlideOut-module-scss-module__tztGla__error",
  "eventInfo": "eventSlideOut-module-scss-module__tztGla__eventInfo",
  "eventMetaLink": "eventSlideOut-module-scss-module__tztGla__eventMetaLink",
  "fadeIn": "eventSlideOut-module-scss-module__tztGla__fadeIn",
  "fadeOut": "eventSlideOut-module-scss-module__tztGla__fadeOut",
  "header": "eventSlideOut-module-scss-module__tztGla__header",
  "host": "eventSlideOut-module-scss-module__tztGla__host",
  "hostAvatar": "eventSlideOut-module-scss-module__tztGla__hostAvatar",
  "hostCard": "eventSlideOut-module-scss-module__tztGla__hostCard",
  "hostInfo": "eventSlideOut-module-scss-module__tztGla__hostInfo",
  "hostInfoDescription": "eventSlideOut-module-scss-module__tztGla__hostInfoDescription",
  "hostInfoName": "eventSlideOut-module-scss-module__tztGla__hostInfoName",
  "infoSection": "eventSlideOut-module-scss-module__tztGla__infoSection",
  "learnMore": "eventSlideOut-module-scss-module__tztGla__learnMore",
  "loadingContainer": "eventSlideOut-module-scss-module__tztGla__loadingContainer",
  "mobileEventMeta": "eventSlideOut-module-scss-module__tztGla__mobileEventMeta",
  "mobileEventMetaContent": "eventSlideOut-module-scss-module__tztGla__mobileEventMetaContent",
  "mobileEventMetaItem": "eventSlideOut-module-scss-module__tztGla__mobileEventMetaItem",
  "mobileEventMetaTitle": "eventSlideOut-module-scss-module__tztGla__mobileEventMetaTitle",
  "mobileFooter": "eventSlideOut-module-scss-module__tztGla__mobileFooter",
  "mobileFooterButton": "eventSlideOut-module-scss-module__tztGla__mobileFooterButton",
  "mobileLocation": "eventSlideOut-module-scss-module__tztGla__mobileLocation",
  "mobileLocationCity": "eventSlideOut-module-scss-module__tztGla__mobileLocationCity",
  "mobileLocationTitle": "eventSlideOut-module-scss-module__tztGla__mobileLocationTitle",
  "mobileMapContainer": "eventSlideOut-module-scss-module__tztGla__mobileMapContainer",
  "mobileTitleProgress": "eventSlideOut-module-scss-module__tztGla__mobileTitleProgress",
  "partnerLink": "eventSlideOut-module-scss-module__tztGla__partnerLink",
  "promoImage": "eventSlideOut-module-scss-module__tztGla__promoImage",
  "registrationCounter": "eventSlideOut-module-scss-module__tztGla__registrationCounter",
  "scaleIn": "eventSlideOut-module-scss-module__tztGla__scaleIn",
  "scaleOut": "eventSlideOut-module-scss-module__tztGla__scaleOut",
  "section": "eventSlideOut-module-scss-module__tztGla__section",
  "sectionHeading": "eventSlideOut-module-scss-module__tztGla__sectionHeading",
  "sectionHeadingHost": "eventSlideOut-module-scss-module__tztGla__sectionHeadingHost",
  "sectionHeadingSponsors": "eventSlideOut-module-scss-module__tztGla__sectionHeadingSponsors",
  "sectionSponsors": "eventSlideOut-module-scss-module__tztGla__sectionSponsors",
  "sidebar": "eventSlideOut-module-scss-module__tztGla__sidebar",
  "slideOutDialog": "eventSlideOut-module-scss-module__tztGla__slideOutDialog",
  "slideOutMenu": "eventSlideOut-module-scss-module__tztGla__slideOutMenu",
  "slideOutOverlay": "eventSlideOut-module-scss-module__tztGla__slideOutOverlay",
  "sponsorLink": "eventSlideOut-module-scss-module__tztGla__sponsorLink",
  "tabletRegisterActions": "eventSlideOut-module-scss-module__tztGla__tabletRegisterActions",
  "title": "eventSlideOut-module-scss-module__tztGla__title",
  "triggerButton": "eventSlideOut-module-scss-module__tztGla__triggerButton",
  "volunteersRequested": "eventSlideOut-module-scss-module__tztGla__volunteersRequested",
  "volunteersRequestedIcon": "eventSlideOut-module-scss-module__tztGla__volunteersRequestedIcon",
  "zoomIn": "eventSlideOut-module-scss-module__tztGla__zoomIn",
  "zoomOut": "eventSlideOut-module-scss-module__tztGla__zoomOut",
});
